import { createSlice } from "@reduxjs/toolkit";

const friendModalSlicer = createSlice({
  name: "friendsModal",
  initialState: {
    sidebarModal: false,
    postEditorModal: false,
    friendActionModal: false,
    selectedFriend: null,
    selectedPost: null,
    showBlockPopup: false,
    showReportPopup: false,
  },
  reducers: {
    toggleSidebarModal: (state) => {
      state.sidebarModal = !state.sidebarModal;
    },
    togglePostEditorModal: (state, action) => {
      state.postEditorModal = state.postEditorModal ? false : action.payload;
    },
    toggleFriendActionModal: (state) => {
      state.friendActionModal = !state.friendActionModal;
      if (!state.friendActionModal) {
        state.selectedFriend = null;
      }
    },
    setSelectedFriend: (state, action) => {
      state.selectedFriend = action.payload?.user || action.payload;
      state.selectedPost = action.payload?.post || null;
    },
    setShowBlockPopup: (state, action) => {
      state.showBlockPopup = action.payload;
      // Close friend modal when showing block popup
      if (action.payload === true) {
        state.friendActionModal = false;
      }
    },
    setShowReportPopup: (state, action) => {
      state.showReportPopup = action.payload;
      // Close friend modal when showing report popup
      if (action.payload === true) {
        state.friendActionModal = false;
      }
    },
    resetFriendModalState: (state) => {
      state.friendActionModal = false;
      state.selectedFriend = null;
      state.selectedPost = null;
      state.showBlockPopup = false;
      state.showReportPopup = false;
    },
  },
});

export const {
  toggleSidebarModal,
  togglePostEditorModal,
  toggleFriendActionModal,
  setSelectedFriend,
  setShowBlockPopup,
  setShowReportPopup,
  resetFriendModalState,
} = friendModalSlicer.actions;

export default friendModalSlicer.reducer;

